import { render, staticRenderFns } from "./DisclaimerCopyrightAndPrivacyLinks.vue?vue&type=template&id=1f20a25c&"
import script from "./DisclaimerCopyrightAndPrivacyLinks.vue?vue&type=script&lang=js&"
export * from "./DisclaimerCopyrightAndPrivacyLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports